"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { useTheme as c } from "../../hooks.js";
import { useIsInverseVariant as v } from "../../theme-variant-context.js";
import { vars as h } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: i, size: a = 24 } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = v(), o = i !== null && i !== void 0 ? i : n ? h.colors.inverse : h.colors.neutralHigh, { skinName: t } = c();
    return t.match(/^o2-new/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "m6.142 13.216 5.852 5.856 5.857-5.856c.463-.464.607-1.212.355-1.856-.248-.608-.783-.964-1.39-.964h-2.144v-7.68a.715.715 0 1 0-1.43 0v9.108h3.57s.035 0 .071.072c.036.104.036.248-.036.32l-4.853 4.856-4.853-4.856c-.072-.068-.072-.212-.036-.32.036-.072.072-.072.072-.072h3.57V2.716a.717.717 0 0 0-1.431-.004v7.68H7.173c-.608 0-1.14.356-1.391.964-.248.644-.104 1.396.36 1.86"
            }),
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M4.143 22h15.702c1.18 0 2.143-.964 2.155-2.144V12a.715.715 0 1 0-1.431 0v7.856a.72.72 0 0 1-.716.716H4.147a.72.72 0 0 1-.716-.716V12A.715.715 0 1 0 2 12v7.856C2 21.036 2.963 22 4.143 22"
            })
        ]
    })) : t.match(/^o2/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "m6.142 13.216 5.852 5.856 5.857-5.856c.463-.464.607-1.212.355-1.856-.248-.608-.783-.964-1.39-.964h-2.144v-7.68a.715.715 0 1 0-1.43 0v9.108h3.57s.035 0 .071.072c.036.104.036.248-.036.32l-4.853 4.856-4.853-4.856c-.072-.068-.072-.212-.036-.32.036-.072.072-.072.072-.072h3.57V2.716a.717.717 0 0 0-1.431-.004v7.68H7.173c-.608 0-1.14.356-1.391.964-.248.644-.104 1.396.36 1.86"
            }),
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M4.143 22h15.702c1.18 0 2.143-.964 2.155-2.144V12a.715.715 0 1 0-1.431 0v7.856a.72.72 0 0 1-.716.716H4.147a.72.72 0 0 1-.716-.716V12A.715.715 0 1 0 2 12v7.856C2 21.036 2.963 22 4.143 22"
            })
        ]
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ e("path", {
            fill: o,
            d: "m5.74 10.956 5.72 5.728a.853.853 0 0 0 1.196 0l5.647-5.655.01-.008.013-.014a.845.845 0 0 0-1.216-1.171l-4.207 4.213V2.999a.844.844 0 0 0-1.69 0v11.05l-4.28-4.286a.844.844 0 0 0-1.193 1.193m16.101 5.955a.844.844 0 0 0-.843-.843.84.84 0 0 0-.84.843v3.244H3.844v-3.244a.845.845 0 0 0-1.689 0v4.087c0 .465.378.843.843.843h18a.844.844 0 0 0 .843-.843z"
        })
    }));
}, g = s;
export { g as default };
